import { HierarchyTable, Column } from "../../../commonUtils/HierarchyTable";
import { SplitPanelUtil } from "../../../commonUtils/SplitPanelUtil";
import i18next from "../../../../i18next";
import './GatewayListTable.scss';
import { Button, Tooltip } from "@scuf/common";

import { ReactComponent as IconSVG } from '../../../../icon/Error.svg';

interface IGatewayListTableProps {
    data: any[];
    loader: boolean;
    onReSync: (data: any) => void;
    basedata: any;
}

const GatewayListTable = ({
    data,
    loader,
    onReSync,
    basedata
}: IGatewayListTableProps) => {
    return (
        <div className="gateway-list-table">
            <div className="no-of-gateway"><p>{data.length} Gateway(s) Associated</p></div>
            <SplitPanelUtil>
                <SplitPanelUtil.Table>
                    <HierarchyTable
                        columnResizeMode="expand"
                        emptyMessage={i18next.t('noRecordFound')}
                        value={data}
                        loading={loader}
                    >
                        <Column 
                            field="Id"
                            header={"Gateway ID"}
                            bodyClassName="gateway-data"
                            className="gateway-data"
                        />
                        <Column 
                            field="Type"
                            header={"Type"}
                        />
                        <Column 
                            field="status"
                            header={"Cloud Sync Status"}
                            renderer={(rowData) => {
                                if(rowData === null) {
                                    return (
                                        <div className="shimmer"><div className="shine"></div></div>
                                    );
                                }
                                if(rowData.status?.toLowerCase() == "inprogress") {
                                    return (
                                        <div><span>Sync in Progress</span></div>
                                    );
                                }else if(rowData.status?.toLowerCase() == "failed") {
                                    return (
                                        <div className="sync-error"><Tooltip element={<IconSVG />} content={rowData.failureReason}/><span>Sync Error</span></div>
                                    );
                                }else if(rowData.status?.toLowerCase() == "completed") {
                                    return (
                                        <div><span>Successful</span></div>
                                    );
                                }
                                if(rowData.status === "API failed") {
                                    return (
                                        <div className="sync-error"><IconSVG /><span>Try again later</span></div>
                                    );
                                }
                                return (
                                    <div><span>N/A</span></div>
                                );
                            }}
                        />
                        <Column 
                            field="action"
                            header={"Action"}
                            bodyClassName="gateway-data-adjust"
                            className="gateway-data-adjust"
                            renderer={(rowdata) => {
                                if(rowdata?.type !== "EBI" || rowdata?.status === "Sync in Progress") {
                                    return (
                                        <></>
                                    )
                                } else if(rowdata?.status === "failed" || rowdata?.status === "completed") {
                                    return (
                                        <Button onClick={() => onReSync(basedata)} type="link" content="Re-sync" disabled={false}/>
                                    )
                                }
                                return (
                                    <Button type="link" content="Re-sync" disabled={true}/>
                                )
                            }}
                        />
                    </HierarchyTable>
                </SplitPanelUtil.Table>
        </SplitPanelUtil>
        </div>
    );
}

export default GatewayListTable;